import { dev } from '@/src/constants/URL'
import APITemplate from '@api/APITemplate'
import { acessoClientes, simulador } from '@constants/URL'
import con from '@services/connection'

class APIclients extends APITemplate {
  _formatToList({
    dados_permissoes,
    dados_profissionais,
    dados_clientes,
    id_profissional,
  }) {
    const dicProfessionals = dados_profissionais.reduce((all, next) => {
      all[next.id_profissional] = next
      return all
    }, {})
    const list = dados_clientes

    return list.map((client) => {
      const outrosProfissionais = Object.entries(
        dados_permissoes[client.id_cliente_app]
      )
        // Buscar profissionais que tem acesso ao cliente
        .filter(([id_profissional, nivel_permissao]) => nivel_permissao >= 0)
        // Retornar os dados dos profissionai
        .map(
          ([id_profissional, nivel_permissao]) =>
            dicProfessionals[id_profissional] || {}
        )

      const hasAccess =
        typeof dados_permissoes[client.id_cliente_app][id_profissional] ===
        'number'
          ? dados_permissoes[client.id_cliente_app][id_profissional] >= 0
          : false

      return {
        ...client,
        id: client.id_cliente_app,
        codigo: client.codigo_corretora,
        nome_cliente: client.nome_cliente,
        id_segmentacao: client.id_segmentacao,
        professional_responsavel:
          dicProfessionals[client.id_profissional_responsavel],
        outros_profissionais: outrosProfissionais,
        has_access: hasAccess,
      }
    })
  }

  _orderList(dados_clientes) {
    return dados_clientes.sort((x, y) => {
      return x.has_access === y.has_access ? 0 : x.has_access ? -1 : 1
    })
  }

  async carregar({ id_profissional } = {}) {
    if (!id_profissional) {
      return {
        status: 404,
        message: 'Profissional não encontrado',
        value: [],
      }
    }
    const r = await con.get(
      acessoClientes.manage // + `?id_profissional=${id_profissional}`
    )

    if (r && r.status === 200) {
      const format = this._formatToList({ ...r.value, id_profissional })
      const order = this._orderList(format)

      r.value = order
    }

    return r || {}
  }

  /**
   *
   * @param id Direto do currentClient.id
   * @returns {Promise<Object>} Dados do cliente
   *      {value: {id, nome_cliente, perfil, qualificado, pl_potencial}}
   */
  async carregarDadosClient({ id }) {
    if (!id) {
      return {
        status: 404,
        message: 'Cliente não encontrado',
        value: {},
      }
    }
    const r = await con.get(simulador.dados_cliente + id)

    return r || {}
  }

  /**
   * Formatar as permissoes de acesso aos clientes para o necessario ao back.
   * Todos os clientes precisam estar nas duas listas.
   * @param {Array} oldData Lista de clientes antiga
   * @param {Array} newData Lista de clientes com permissoes novas
   * @param {Integer} id_profissional Identificar do profissional
   * @returns
   */
  _formatPermissions({ oldData, newData, id_profissional }) {
    const result = {
      remove_access: { [id_profissional]: [] },
      read_access_add: { [id_profissional]: [] },
    }
    const oldPermissions = oldData.reduce((all, next) => {
      all[next.id] = next
      return all
    }, {})
    newData.forEach((newPermission) => {
      const oldPermission = oldPermissions[newPermission.id]
      if (oldPermission) {
        if (oldPermission.has_access !== newPermission.has_access) {
          if (oldPermission.has_access >= newPermission.has_access) {
            result.remove_access[id_profissional].push(newPermission.id)
          } else {
            result.read_access_add[id_profissional].push(newPermission.id)
          }
          if (newPermission.has_access === null) {
            console.error(
              `Acesso ao cliente inválido: ${JSON.stringify(newPermission)}`
            )
          }
        }
      } else {
        console.error(
          `Permissao anterior nao encontrada: ${JSON.stringify(newPermission)}`
        )
      }
    })
    return result
  }

  async salvar({
    permissoesAntigas = [],
    permissoesNovas = [],
    id_profissional,
  } = []) {
    const data = this._formatPermissions({
      oldData: permissoesAntigas,
      newData: permissoesNovas,
      id_profissional: id_profissional,
    })
    data.read_access_add = JSON.stringify(data.read_access_add)
    data.remove_access = JSON.stringify(data.remove_access)

    const r = await con.post(acessoClientes.manage, data)

    return r || {}
  }

  async importFile(file) {
    const r = await con.post(dev.espelho, file)

    return r || {}
  }
}

const apiClients = new APIclients()
export { apiClients }
